import React from 'react'
import type { PageContext } from '@which/glide-ts-types'

import { useFeatureIsOn } from '@growthbook/growthbook-react'

import type { WCDRouteProps } from '.'
import { Page } from './components/Page'

const ReviewsVertical = ({ context }: { context: PageContext }) => {
  const enableReviewsVertical = useFeatureIsOn('pie-714-vertical-template-reviews')

  return enableReviewsVertical ? (
    <Page pagePath="vertical/ReviewsPage" />
  ) : (
    <Page pagePath="vertical/VerticalPage" template="Reviews Vertical" context={context} />
  )
}

const NewsVertical = () => {
  const enableNewsVertical = useFeatureIsOn('pie-810-vertical-template-news')

  return enableNewsVertical ? (
    <Page pagePath="vertical/NewsPage" />
  ) : (
    <Page pagePath="vertical/VerticalPage" template="News Vertical" context="news" />
  )
}

const NewsListing = () => {
  const enableNewsListing = useFeatureIsOn('pie-810-listing-template-news')

  return enableNewsListing ? (
    <Page pagePath="vertical/NewsListingPage" />
  ) : (
    <Page pagePath="vertical/VerticalPage" template="News Full Listing" context="news" />
  )
}

export const verticalPageRoutes: WCDRouteProps = [
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(about-which|help)',
    component: () => <Page pagePath="vertical/VerticalPage" template="About Which Vertical" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(about-which)/sitemap',
    component: () => <Page pagePath="vertical/VerticalPage" template="Sitemap Vertical" />,
  },
  {
    live: false,
    exact: true,
    path: '/:verticalSlug(campaigns)',
    component: () => <Page pagePath="vertical/VerticalPage" template="Campaigns Vertical" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(consumer-rights)',
    component: () => (
      <Page pagePath="vertical/VerticalPage" template="CR Vertical" context="consumer-rights" />
    ),
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(money)',
    component: () => <ReviewsVertical context="money" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(my-appointments)',
    component: () => <Page pagePath="vertical/VerticalPage" template="My Appointments Vertical" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(news)/latest',
    component: () => <NewsListing />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(news)',
    component: () => <NewsVertical />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(pension-scheme)',
    component: () => <Page pagePath="vertical/VerticalPage" template="Pension Scheme Vertical" />,
  },
  {
    live: false,
    exact: true,
    path: '/:verticalSlug(policy-and-insight)',
    component: () => (
      <Page
        pagePath="vertical/VerticalPage"
        template="Policy and Insight Vertical"
        context="policy-and-insight"
      />
    ),
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(tech-and-appliances|technology|appliances|cars|travel|home-and-garden|baby-and-child|family|health)',
    component: () => <ReviewsVertical context="reviews" />,
  },
]
